import { flattenMessages } from './helpers/flatternMessages';
import en from './messages/en';
const messages = {
    en: flattenMessages(en)
};
const getMessages = (locale)=>messages[locale];
export { messages, getMessages };
